import React from 'react';
import { Link } from 'react-router-dom';
import facebookIcon from '../icons/iconoir_facebook.svg';
import linkedInIcon from '../icons/circum_linkedin.svg';

const Footer = () => {
  return (
    <footer className="bg-[#9259E8] text-white pt-4 lg:pt-10  pb-4 rounded-t-3xl lg:px-12">
      <div className="container px-4 flex flex-col md:flex-row justify-between lg:items-center">
        {/* Company Description */}
        <div className="flex flex-col items-center justify-between">
          <div className="flex flex-row items-center space-x-2 mb-2 lg:mb-0 ">
            <img alt="Logo" src="/whiteLogo.svg" className="w-16 h-16" />
            <div>
              <Link to="/" className="text-2xl">
                MakerSharks
              </Link>
              <p className="lg:mt-2 hidden lg:block lg:text-left max-w-sm">
                hello@makersharks.com
              </p>
            </div>
          </div>
          <div className="flex flex-row text-[18px] items-center justify-center space-x-4 lg:hidden">
            <Link
              to="/about"
              className="hover:text-purple-800 transtion-all duration-300"
            >
              About Us
            </Link>
          </div>
          <div className="lg:hidden flex m-2 space-x-6 md:mt-0">
            <a
              href="https://www.facebook.com/profile.php?id=61565553175156"
              className="text-white hover:text-gray-300"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img alt="facebook" src={facebookIcon} className="h-8 w-8" />
            </a>
            <a
              href="https://www.linkedin.com/company/makersharks/"
              className="text-white hover:text-gray-300"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img alt="linkedIn" src={linkedInIcon} className="h-8 w-8" />
            </a>
          </div>
        </div>

        {/* Links Section */}
        <div className="hidden lg:block flex flex-row mt-6 items=center justify-center space-x-4 lg:text-[18px] md:mt-0 md:space-x-16">
          <Link
            to="/about"
            className="hover:text-purple-800 transtion-all duration-300"
          >
            About Us
          </Link>
        </div>

        {/* Social Media Icons */}
        <div className="hidden lg:block lg:flex lg:space-x-8 lg:mt-0">
          <a
            href="https://www.facebook.com/profile.php?id=61565553175156"
            className="text-white hover:text-gray-300"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img alt="facebook" src={facebookIcon} className="h-8 w-8" />
          </a>
          <a
            href="https://www.linkedin.com/company/makersharks/"
            className="text-white hover:text-gray-300"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img alt="linkedIn" src={linkedInIcon} className="h-8 w-8" />
          </a>
        </div>
      </div>
      <p className="text-center text-[12px]">
        © 2024 Copyright, All Right Reserved
      </p>
    </footer>
  );
};

export default Footer;
